import React, { useState, useEffect, useReducer } from 'react';
import axios from 'axios';
import { Button, Modal, ModalHeader, ModalBody, ModalFooter, Label, Input, Table, Alert } from 'reactstrap';
import { useNavigate } from 'react-router-dom';
import BASE_URL from '../Services/Employees';
import withReactContent from 'sweetalert2-react-content';
import Swal from 'sweetalert2';

const CenterDropdown = ({ centers, selectedCenters, onSelect, index }) => {
    const filteredCenters = centers.filter(center => !selectedCenters.includes(center));
    return (
        <div className="col-md-4 px-1" key={index}>
            <div className="mb-3">
                <Label style={{ textAlign: 'center' ,color: 'grey', paddingTop: '2%',fontSize:"16px" , fontWeight: 'bold' }} for={`centerSelect${index}`}>District Preference {index + 1}</Label>
                <Input type="select" id={`selectcenters${index}`} onChange={e => onSelect(e.target.value)}>
                    <option value="">Select District</option>
                    {filteredCenters.map(center => (
                        <option key={center} value={center}>
                            {center}
                        </option>
                    ))}
                </Input>
            </div>
        </div>
    );
};

const ExamCenterSelection = () => {
    const [courses, setCourses] = useState([]);
    const [centres, setCentres] = useState([]);
    const [selectedCenters, setSelectedCenters] = useState(['', '', '']);
    const [selectedCenterIndex, setSelectedCenterIndex] = useState(0);
    const [selectedCourse, setSelectedCourse] = useState('');
    const [showModal, setShowModal] = useState(false);
    const [validationMessage, setValidationMessage] = useState('');
    const [eventName, setEventName] = useState('');
    const [message, setMessage] = useState('');
    const [responseMsg, setResponseMsg] = useState('');
    const [messageType, setMessageType] = useState('');
    const[reduceValue,forceUpdate]=useReducer(x=>x+1,0); // 'error' or 'success'

    const navigate = useNavigate();

    useEffect(() => {
        if (responseMsg !== '') {
          withReactContent(Swal).fire({
            text: responseMsg,
            allowOutsideClick:false
          });
        }
        setResponseMsg("");
      }, [responseMsg]);


    useEffect(() => {
        fetchExams();
    }, [reduceValue]);

    const fetchExams = async () => {
        try {
            const response = await axios.get(`${BASE_URL}/api/exam`, { headers: { "Authorization": localStorage.getItem("tokenId") } });
            console.log(response)
             if (response.status === 200) {
                setCourses(response.data.data.courses);
                setCentres(response.data.data.centers.map(center => center.name));
                 setEventName(response.data.data.event.eventName);
                //forceUpdate();
             } 
             else {
                if (response.status === 208) {
                    setMessageType('error');
                    setMessage(response.data.message);   
                    navigate('/dashboard/selectedexam');
                }
            }
        } catch (error) {
            setMessageType('error');
            setMessage(error.response.data.message);
        }
    };

    const handleCenterSelect = (centerName, index) => {
        setSelectedCenters(prevSelectedCenters => {
            const updatedSelectedCenters = [...prevSelectedCenters];
            updatedSelectedCenters[index] = centerName;
            return updatedSelectedCenters;
        });
        setSelectedCenterIndex(index + 1);
    };

    const handleConfirmation = async () => {
        try {
            const priorityData = {
                course: { name: selectedCourse },
                eventDto: { eventName: eventName },
                centres: selectedCenters.slice(0, selectedCenterIndex).map((center, index) => ({
                    name: center,
                    priority: index + 1
                }))
            };
            const response = await axios.post(`${BASE_URL}/api/saveCenterPreference`, priorityData, { headers: { "Authorization": localStorage.getItem("tokenId") } });
            setShowModal(false);
            setMessageType('success');
            setResponseMsg(response.data);
            setSelectedCourse('');
            setSelectedCenters(['', '', '']);
            setSelectedCenterIndex(0);
            ['examSelect', 'selectcenters0', 'selectcenters1', 'selectcenters2'].forEach(id => {
                document.getElementById(id).value = '';
            });
            setTimeout(() => {
                navigate('/dashboard/selectedexam');
              }, 1000);
        } catch (error) {
            //setMessageType('error');
           setResponseMsg(error.response.data);
        //    setTimeout(() => {
        //     navigate('/dashboard/centreselect');
        //   }, 1000);
        }
    };

    const handleSuccess = () => {
        if (selectedCourse === '' || selectedCenters.includes('')) {
            setValidationMessage('Please select all required fields before submitting.');
        } else {
            setValidationMessage('');
            setShowModal(true);
        }
    };

    const handleCloseModal = () => {
        setShowModal(false);
    };

    return (
        <div >
            {message && (
                <Alert className='text-center' color={messageType === 'error' ? 'danger' : 'success'}>
                    {message}
                </Alert>
            )}
            {messageType !== 'error' && (
                <div className="card border-0" style={{ background: "white" }}>
                    {/* <div className='row' style={{ borderBottom: '2px solid #ffc107' }}> */}
                        {/* <div className='col-md-4'>
                            <h5 className="" style={{ color: '#a2806f', fontWeight: '10px', textAlign: "center" }}>Test and District Selection</h5>
                        </div> */}
                        <div className="card-header " style={{backgroundColor:"transparent"}} >
          <h5 className="card-title text-center mb-0 py-2">Test and District Selection</h5>
        </div>
        <div className="card-body">
                        <h6 style={{ textAlign: "center" }}>(Exam Event:<strong>{eventName}</strong> )</h6>
                    {/* </div> */}
                   
                    <div className='text-center'>
                        <h6 id='h5' style={{ color: 'red' }}>Dear Candidate,
                            carefully fill out the following information to proceed with your Test and District Selection for HPTI Exam. <br /> Note: Please be aware that your exam district may differ from the selected one if seats are filled in those districts.</h6>
                    </div>
                    <div className="row justify-content-center">
                        <div className="col-md-6">
                            <div className="mb-3">
                                <Label for="examSelect" style={{ textAlign: 'center' ,color: 'grey', paddingTop: '2%',fontSize:"16px" , fontWeight: 'bold' }}>Select Test</Label>
                                <Input type="select" id="examSelect" onChange={e => setSelectedCourse(e.target.value)}>
                                    <option value="">Select Test</option>
                                    {courses.map(exam => (
                                        <option key={exam.name} value={exam.name}>
                                            {exam.name}
                                        </option>
                                    ))}
                                </Input>
                            </div>
                        </div>
                    </div>
                    <div className="row justify-content-center mt-4">
                        {selectedCenters.map((selectedCenter, index) => (
                            <CenterDropdown
                                key={index}
                                centers={centres}
                                selectedCenters={selectedCenters.filter((_, idx) => idx !== index)}
                                onSelect={centerName => handleCenterSelect(centerName, index)}
                                index={index}
                            />
                        ))}
                    </div>
                    {validationMessage && (
                        <div className="row justify-content-center mt-2">
                            <div className="col-md-6 text-center">
                                <p style={{ color: 'red' }}>{validationMessage}</p>
                            </div>
                        </div>
                    )}
                    <div className="row justify-content-center mt-4">
                        <div className="col-md-6" style={{ textAlign: "center", marginBottom: "9px" }}>
                            <Button   className='btn btn-success' onClick={handleSuccess}>Submit</Button>
                        </div>
                    </div>
                    <Modal isOpen={showModal} toggle={handleCloseModal} className='text-center' style={{marginTop:"10%"}}>
                        <ModalHeader toggle={handleCloseModal}>Selected Test</ModalHeader>
                        <ModalBody >
                            <p>Selected Test:<b> {selectedCourse}</b></p>
                            <Table bordered>
                                <thead>
                                    <tr>
                                        <th>Sr.No</th>
                                        <th>Selected Centers</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {selectedCenters.slice(0, selectedCenterIndex).map((center, index) => (
                                        <tr key={index}>
                                            <td>{index + 1}</td>
                                            <td>{center}</td>
                                        </tr>
                                    ))}
                                </tbody>
                            </Table>
                        </ModalBody>
                        <ModalFooter className='justify-content-around'>
                            
                            <Button  className='btn btn-success'  onClick={handleConfirmation}>Confirm</Button>
                            <Button   className='btn btn-danger' onClick={handleCloseModal}>Close</Button>
                          
                        </ModalFooter>
                    </Modal>
                </div>
                </div>
            )}
        </div>
    );
};

export default ExamCenterSelection;
